// Classi condivise dai template dell'area gestionale: stesso vocabolario della home e del selettore lingua
// (carta, inchiostro, carte d'imbarco con ombra piena, strisce colorate e perforazione). Token in src/index.css.

/** Titolo di pagina: Fraunces come il titolo della home. */
export const pageTitleClass = 'font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl'

/**
 * Superficie principale (tabelle, form, dialoghi): carta d'imbarco con bordo e ombra d'inchiostro.
 * Con una `.ticket-perforation` dentro serve `overflow-hidden`, altrimenti le tacche escono dal bordo.
 */
export const surfaceClass = 'rounded-xl border-2 border-ink bg-paper shadow-[4px_4px_0_var(--color-ink)]'

/** Striscia d'intestazione di una superficie, come "Lingua" nel selettore; di solito seguita da `.ticket-perforation`. */
export const stripClass = 'bg-sea/15 font-body text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-sea-ink'

/** Matrice staccabile in fondo a form e dialoghi, sotto una `.ticket-perforation`. */
export const stubClass = 'flex flex-wrap items-center justify-end gap-3 bg-paper-deep/70 px-5 py-4 sm:px-6'

export const errorClass = 'rounded-lg border border-coral/60 bg-coral/10 px-4 py-3 text-sm text-coral-ink'

// Altezza fissa (38px) uguale per input, date e select; leading-6 lascia spazio alle discendenti
// (le "g" di gg/mm/aaaa), che Firefox taglia nei campi data con alcuni font di sistema.
// Bordo ink-soft: il contorno di un campo deve avere contrasto 3:1 sulla carta.
export const inputClass =
  'h-9.5 w-full rounded-lg border border-ink-soft/70 bg-paper px-3 py-1.5 text-sm leading-6 text-ink placeholder:text-ink-soft/70 transition-colors focus:border-ink focus:outline-none focus:ring-2 focus:ring-sea/30 disabled:bg-paper-deep disabled:text-ink-soft'

export const labelClass = 'mb-1.5 block text-sm font-medium text-ink'

export const hintClass = 'mt-1.5 block text-xs text-ink-soft'

/** Casella di spunta nel colore dell'inchiostro. */
export const checkboxClass = 'size-4 accent-ink disabled:opacity-50'

const button =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border px-4 py-2 text-sm font-medium transition-[background-color,color,translate] duration-150 active:translate-y-px disabled:cursor-not-allowed disabled:opacity-50 disabled:active:translate-y-0'

export const primaryButton = `${button} border-ink bg-ink text-paper hover:bg-ink/85`
/** Come "Area riservata" nell'header del sito: bordo d'inchiostro che si riempie al passaggio. */
export const secondaryButton = `${button} border-ink bg-paper text-ink hover:bg-ink hover:text-paper`
/** Azione alternativa accanto a quella principale (es. "Invita utente" accanto a "Nuovo utente"). */
export const outlineButton = secondaryButton
export const dangerButton = `${button} border-coral-ink bg-coral-ink text-paper hover:bg-coral-ink/85`

export const iconButton = 'inline-flex rounded-md p-2 text-ink-soft transition-colors hover:bg-ink/5 hover:text-ink'

export const linkButton = 'rounded text-sm font-medium text-sea-ink underline-offset-4 hover:underline'

/** Etichetta di stato o categoria nelle tabelle; il tono si aggiunge (es. `bg-sea/15 text-sea-ink`). */
export const badgeClass = 'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium'
